<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M15.8333 6.1098V3.6098C15.8333 3.3888 15.7455 3.1768 15.5893 3.0206C15.433 2.8643 15.221 2.7765 15 2.7765H4.1667C3.7246 2.7765 3.3007 2.9521 2.9882 3.2647C2.6756 3.5772 2.5 4.0011 2.5 4.4432C2.5 4.8852 2.6756 5.3091 2.9882 5.6217C3.3007 5.9342 3.7246 6.1098 4.1667 6.1098H16.6667C16.8877 6.1098 17.0997 6.1976 17.256 6.3539C17.4122 6.5102 17.5 6.7222 17.5 6.9432V10.2765M17.5 10.2765H15C14.558 10.2765 14.1341 10.4521 13.8215 10.7646C13.5089 11.0772 13.3333 11.5011 13.3333 11.9432C13.3333 12.3852 13.5089 12.8091 13.8215 13.1217C14.1341 13.4342 14.558 13.6098 15 13.6098H17.5C17.721 13.6098 17.933 13.522 18.0893 13.3658C18.2455 13.2095 18.3333 12.9975 18.3333 12.7765V11.1098C18.3333 10.8888 18.2455 10.6768 18.0893 10.5206C17.933 10.3643 17.721 10.2765 17.5 10.2765Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.5 4.8599V16.5266C2.5 16.9687 2.6756 17.3925 2.9882 17.7052C3.3007 18.0177 3.7246 18.1933 4.1667 18.1933H16.6667C16.8877 18.1933 17.0997 18.1055 17.256 17.9492C17.4122 17.7928 17.5 17.581 17.5 17.36V14.0266"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconWallet',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
